import {defineMessages} from "@project/i18n";

export const clientFieldLabelIds = {
  active: "fields.client.active",
  address: "fields.client.address",
  companyId: "fields.client.companyId",
  companyName: "fields.client.companyName",
  country: "fields.client.country",
  leadId: "fields.client.leadId",
  logoUrl: "fields.client.logoUrl",
  phoneNumber: "fields.client.phoneNumber",
  phonePrefix: "fields.client.phonePrefix",
  type: "fields.client.type",
  websiteUrl: "fields.client.websiteUrl",
} as const;

export const clientFieldMessages = defineMessages({
  active: {
    id: "fields.client.active",
    defaultMessage: "Active",
    description: "Client field label for active status",
  },
  address: {
    id: "fields.client.address",
    defaultMessage: "Address",
    description: "Client field label for postal address",
  },
  companyId: {
    id: "fields.client.companyId",
    defaultMessage: "Company ID",
    description: "Client field label for company registration identifier",
  },
  companyName: {
    id: "fields.client.companyName",
    defaultMessage: "Company name",
    description: "Client field label for company name",
  },
  country: {
    id: "fields.client.country",
    defaultMessage: "Country",
    description: "Client field label for country",
  },
  leadId: {
    id: "fields.client.leadId",
    defaultMessage: "Lead ID",
    description: "Client field label for source lead ID",
  },
  logoUrl: {
    id: "fields.client.logoUrl",
    defaultMessage: "Logo URL",
    description: "Client field label for logo URL",
  },
  phoneNumber: {
    id: "fields.client.phoneNumber",
    defaultMessage: "Phone number",
    description: "Client field label for phone number",
  },
  phonePrefix: {
    id: "fields.client.phonePrefix",
    defaultMessage: "Phone prefix",
    description: "Client field label for phone prefix",
  },
  type: {
    id: "fields.client.type",
    defaultMessage: "Client type",
    description: "Client field label for client type",
  },
  websiteUrl: {
    id: "fields.client.websiteUrl",
    defaultMessage: "Website URL",
    description: "Client field label for website URL",
  },
});
